export default __webpack_public_path__ + "static/media/icon.3650b09f.svg";